"use client";

import { Stack, Box, BoxProps } from "@chakra-ui/react";
import { ReactNode, FC, ReactElement } from "react";

type Props = BoxProps & {
  children: ReactNode;
  header: ReactElement;
};

const PageLayout: FC<Props> = ({ header, children, ...props }) => (
  <Box
    display="grid"
    gridTemplateRows="auto 1fr"
    gridTemplateAreas={`
      "header"
      "content"
    `}
    minHeight="100vh"
    {...props}
  >
    {header}

    <Stack
      as="main"
      pt={[6, null, 10]}
      pb={6}
      mx="auto"
      w="100%"
      maxWidth={1200}
      px={5}
      gap={4}
      display="flex"
      gridArea="content"
      // https://stackoverflow.com/a/61960229
      minWidth={0}
    >
      <Box display="flex" flexDirection="column" flexGrow={1}>
        {children}
      </Box>
    </Stack>
  </Box>
);

export default PageLayout;
